<template>
  <div style="color: #fff">
    <div id="container" style="height: 100vh; width: 100%"></div>
    <!-- 弹窗内容 -->
    <div ref="Popup" v-show="infoWindow" class="marker-content-div">
      <img
        @dblclick="
          $store.commit(
            'set_dbClickImg',
            infoWindowContent.storageUrl1 || '../../static/img/noData.jpg'
          )
        "
        style="width: 100%"
        :src="infoWindowContent.thumbnailUrl || '../../static/img/noData.jpg'"
      />
      <div>过车时间：{{ infoWindowContent.passingTimeFormat }}</div>
      <div>地点：{{ infoWindowContent.place }}</div>
    </div>
    <!-- 弹窗内容 -->
    <div class="map-search-div">
      <div class="title">轨迹查询</div>
      <div style="height: 166px; padding: 10px">
        <el-form
          :inline="true"
          :model="formInline"
          :size="'small'"
          class="demo-form-inline"
        >
          <el-form-item label="车牌号码">
            <el-input
              style="width: 150px"
              v-model="formInline.plateNo"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="车牌颜色">
            <el-select
              style="width: 96px"
              v-model="formInline.plateColor"
              placeholder="请选择"
            >
              <el-option
                v-for="(item6, key6) in $store.state.dictionary.PLATECOLOR"
                :key="key6"
                :label="item6.name"
                :value="item6.code"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="过车时间">
            <el-date-picker
              style="width: 330px"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="formInline.time"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="~"
              @change="changeDate"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div style="padding: 0 10px">
          <el-button :size="'small'" style="width: 388px" type="primary" @click="onSubmit"
            >查询</el-button
          >
        </div>
        <div style="border-bottom: 1px #3a424c dashed; padding-bottom: 16px"></div>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="passingTimeFormat" label="时间" width="180">
          </el-table-column>
          <el-table-column prop="place" label="地址"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { setTime } from "@/commons/util.js";

export default {
  data() {
    let plateNo = "";
    let time = setTime(90);
    if (process.env.NODE_ENV == "development") {
      plateNo = "浙A561BQ";
      time = ["2022-09-22 00:00:00", "2022-09-23 00:00:00"];
    }
    return {
      infoWindowContent: {},
      plateColor: [],
      tableData: [],
      map: null,
      infoWindow: null,
      path: [],
      formInline: {
        plateNo,
        plateColor: "",
        time,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      item1: "",
    };
  },
  methods: {
    onSubmit() {
      this.getdata();
    },
    changeDate(dateArr) {
      // if (
      //   new Date(dateArr[0]).getTime() <
      //   new Date(dateArr[1]).getTime() - 60000 * 60 * 24
      // ) {
      //   this.$message.error("不能超过24H");
      //   this.formInline.time = "";
      // }
    },
    getdata() {
      const data = {
        beginTime: this.formInline.time[0],
        endTime: this.formInline.time[1],
        pageIndex: 1,
        pageRow: 1000,
        plateColor: this.formInline.plateColor,
        plateNo: this.formInline.plateNo,
      };
      this.path = [];
      this.$http.POST_track(data).then((res) => {
        this.tableData = res.data;
        this.map.clearMap();
        if (this.tableData !== null && this.tableData.length > 1) this.drawLine();
      });
    },
    initmap() {
      this.map = new AMap.Map("container", {
        viewMode: "2D", // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
        zoom: 12, //初始化地图层级
        center: [121.032545, 30.595264], //地图中心点
        // mapStyle: "amap://styles/3697a28802fb96c2635a893a430481ff",
        mapStyle: "amap://styles/8e9dc097afd432a386f14670244eca1c",
        // mapStyle: 'amap://styles/blue'
      });

      // 缩放地图到合适的视野级别
    },
    drawLine() {
      let that = this;
      this.tableData.forEach((item, index) => {
        this.path.push([item.longitude, item.latitude]);
        let markerSrc = "";
        if (item.deviceType == "1") {
          markerSrc = "../../static/img/map-icon/camera.png";
        } else if (item.deviceType == "2") {
          markerSrc = "../../static/img/map-icon/zhaji.png";
        } else if (item.deviceType == "4") {
          markerSrc = "../../static/img/map-icon/qiu.png";
        }
        let marker = new AMap.Marker({
          map: that.map,
          icon: markerSrc,
          position: [item.longitude, item.latitude],
          offset: new AMap.Pixel(-13, -40),
        });
        marker.on("click", () => {
          that.markerClick(item);
        });
      });
      const carMarker = new AMap.Marker({
        map: that.map,
        position: this.path[0],
        icon: `/static/img/car-model.png`,
        offset: new AMap.Pixel(-10, -8),
        autoRotation: true,
        // angle:-90
      });
      // 绘制轨迹
      var polyline = new AMap.Polyline({
        map: that.map,
        showDir: false,
        strokeColor: "#AF5", //线颜色
        strokeWeight: 6 //线宽

      });
      //查询轨迹,绘制轨迹
      var driving = new AMap.Driving({
        // map: this.map,
        hideMarkers: true
      });
      const arr2 = that.path.slice(1, -1);
      const waypoints = arr2.map((item) => {
        item = new AMap.LngLat(...item)
        return item
      })
      let drivingPath = []
      // 根据起终点经纬度规划驾车导航路线
      driving.search(new AMap.LngLat(...that.path[0]), new AMap.LngLat(...that.path[that.path.length - 1]), {
        waypoints
      },
        function (status, result) {
          // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          if (status === 'complete') {
            // console.log('绘制驾车路线完成')
            // console.log(result);
            result.routes[0].steps.forEach(element => {
              drivingPath = [...drivingPath, ...element.path]
            });
            // 绘制轨迹
            new AMap.Polyline({
              map: that.map,
              path: drivingPath,
              showDir: false,
            });
              that.map.setCenter(drivingPath[0], true)
              that.map.setZoomAndCenter(15, drivingPath[0]);
            // 绘制小车与轨迹
            carMarker.on('moving', function (e) {
              polyline.setPath(e.passedPath);
              // that.map.setCenter(e.target.getPosition(), true)
            });
            carMarker.moveAlong(drivingPath,  { duration: 500,autoRotation: true });
          } else {
            console.log('获取驾车数据失败：' + result)
          }
        }
      );
    },
    markerClick(marker) {
      this.infoWindowContent = marker;
      const HTML = this.$refs.Popup;
      this.infoWindow = new AMap.InfoWindow({
        content: HTML,
        autoMove: true,
        retainWhenClose: true,
        position: [marker.longitude, marker.latitude],
        closeWhenClickMap: true, // 点击全屏地图关闭信息窗口
        offset: new AMap.Pixel(0, -40),
      });
      this.infoWindow.open(this.map);
    },
  },
  mounted() {
    this.initmap();
    this.plateColor = JSON.parse(sessionStorage.getItem("dictionary")).PLATECOLOR;
  },
};
</script>

<style lang="scss">
.marker-content-div {
  color: #222;
  padding: 10px;
  line-height: 26px;
}
.el-button--text {
  display: none;
}
.table-list .el-table {
  background: none;
  color: #fff;
}
.el-table td.el-table__cell {
  border-bottom: 1px solid #0f3a9e;
}
.el-table th.el-table__cell.is-leaf {
  border: none;
}
.table-list .el-table tr {
  background: none;
  color: #fff;
}
.table-list .el-table th.el-table__cell {
  background: #082c7e;
}
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: none;
}
input::-webkit-input-placeholder {
  font-size: 14px;
}

.el-form-item__label {
  font-size: 14px;
  color: #fff;
}
.el-input__inner {
  font-size: 14px;
}

.map-search-div {
  max-height: 60%;
  display: flex;
  flex-direction: column;
  .table-list {
    text-align: center;
    width: 100%;
    flex: 1;
    padding: 10px;
    line-height: 28px;
    overflow: auto;
  }
  position: absolute;
  width: 430px;
  left: 0.2rem;
  top: 0.9rem;
  display: flex;
  flex-direction: column;
  background: rgba(1, 15, 32, 0.9);
  box-shadow: 3px 3px 5px rgba(56, 139, 240, 0.4);
  .title {
    height: 42px;
    line-height: 42px;
    padding-left: 20px;
    font-size: 16px;
    color: #fff;
    background-image: linear-gradient(to right, rgb(5, 173, 195), rgba(3, 90, 141, 0.4));
  }
}
</style>



// WEBPACK FOOTER //
// src/views/search/map.vue